import React from 'react';
import Lottie from 'lottie-react';
import animationData from './animation_lntvd1qz.json';

const containerStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh', // This sets the container to full viewport height
};

export default function Contact_mg() {
  return (
    <div className='container' style={containerStyle}>
      <h1 style={{ textAlign: 'center', color: 'white', marginTop: 100 }}>
        SCROLL DOWN TO CONTACT
      </h1>
      <Lottie animationData={animationData} style={{ width: '20%' ,marginTop:100}} />
    </div>
  );
}
